import { useEffect } from 'react';

const useScript = (url) => {
  function isLoadedScript(lib) {
    return document.querySelectorAll(`[src="${lib}"]`).length > 0;
  }
  useEffect(() => {
    if (!isLoadedScript) {
      const script = document.createElement('script');
      document.body.appendChild(script);
      return () => {
        document.body.removeChild(script);
      };
    }
  }, [url]);
};

export default useScript;
